import React from 'react';
import '../styles/RecipeStats.css';

const RecipeStats = ({ recipe }) => {
    const formatCookingTime = (minutes) => {
        if (!minutes) return 'No time specified';
        if (minutes < 60) return `${minutes}m`;
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
    };

    const getDifficulty = (recipe) => {
        const ingredients = recipe.ingredients || [];
        const cookingTime = recipe.cooking_time || 0;
        
        let difficultyScore = 0;
        if (ingredients.length > 15) difficultyScore += 2;
        else if (ingredients.length > 10) difficultyScore += 1;
        
        if (cookingTime > 120) difficultyScore += 2;
        else if (cookingTime > 60) difficultyScore += 1;
        
        if (difficultyScore <= 2) return { level: 'Easy', icon: '🟢' };
        if (difficultyScore <= 4) return { level: 'Medium', icon: '🟡' };
        return { level: 'Hard', icon: '🔴' };
    };

    const ingredients = recipe.ingredients || [];
    const difficulty = getDifficulty(recipe);

    return (
        <div className="recipe-stats">
            <div className="stat-item">
                <span className="stat-label">Ingredients</span>
                <span className="stat-value">{ingredients.length}</span>
            </div>
            
            <div className="stat-item">
                <span className="stat-label">Cook Time</span>
                <span className="stat-value">{formatCookingTime(recipe.cooking_time)}</span>
            </div>
            
            <div className="stat-item">
                <span className="stat-label">Difficulty</span>
                <span className="stat-value">{difficulty.level}</span>
            </div>
        </div>
    );
};

export default RecipeStats; 